// 批量操作
export const elementMixins = {
  methods: {
    clearSelection(...args) {
      this.$refs.generalTable.clearSelection(...args);
    },
    toggleRowSelection(...args) {
      this.$refs.generalTable.toggleRowSelection(...args);
    },
    toggleAllSelection(...args) {
      this.$refs.generalTable.toggleAllSelection(...args);
    },
    toggleRowExpansion(...args) {
      this.$refs.generalTable.toggleRowExpansion(...args);
    },
    setCurrentRow(...args) {
      this.$refs.generalTable.setCurrentRow(...args);
    },
    clearSort(...args) {
      this.$refs.generalTable.clearSort(...args);
    },
    clearFilter(...args) {
      this.$refs.generalTable.clearFilter(...args);
    },
    doLayout(...args) {
      this.$refs.generalTable.doLayout(...args);
    },
    sort(...args) {
      this.$refs.generalTable.sort(...args);
    }
  }
};
